import {BASEHOST_ARCHIVE} from '../../../pub/config/baseHost'

export const getPrivatePot = BASEHOST_ARCHIVE + "/dishListDetail/getPrivatePot";
export const add = BASEHOST_ARCHIVE + "/proprivatecustom/add";
export const getDishPot = BASEHOST_ARCHIVE + "/dishListDetail/getDishPot";
export const getPrivateShareInfo = BASEHOST_ARCHIVE + "/privateShare/getPrivateShareInfo";
export const getJsParams = BASEHOST_ARCHIVE + "/CaterWeixin/getJsParams";
export const sendMobileCodeByHHT = BASEHOST_ARCHIVE + "/member/sendMobileCodeByHHT";// 获取验证码
export const CheckVerificationCode = BASEHOST_ARCHIVE + "/member/CheckVerificationCode";// 校验验证码
export const addNewDishPot = BASEHOST_ARCHIVE + "/dishListDetail/addNewDishPot";// 保存新接口


export const getVerificationCode = BASEHOST_ARCHIVE + "/dishListDetail/getVerificationCode";// 发送短信验证码
export const byMobile = BASEHOST_ARCHIVE + "/dishListDetail/byMobile";                    //校验码验证
export const batchCollectionCustomizationPot = BASEHOST_ARCHIVE + "/dishListDetail/batchCollectionCustomizationPot";       //收藏
export const getBatchCustomizationPotDetail = BASEHOST_ARCHIVE + "/dishListDetail/getBatchCustomizationPotDetail";     //列表




// WEBPACK FOOTER //
// ./src/components/share/config/api.js